export class RdsNativePitrNetworkConfig {
    'subnetGroupName';
    'securityGroupIds';
    'isPubliclyAccessible';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnetGroupName",
            "baseName": "subnetGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "isPubliclyAccessible",
            "baseName": "isPubliclyAccessible",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RdsNativePitrNetworkConfig.attributeTypeMap;
    }
    constructor() {
    }
}
